module.exports = __webpack_public_path__ + "img/1-2.2e9dc283.png";